<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      怡海站<br>
站点介绍<br>
怡海站位深圳市南山区怡海大道和月亮湾大道之间，车站周边规划已商业、办公为主。车站为地下站，地下一层为站厅层，地下二层为站台层，共设置两个出入口，为A出入口和C出入口，B出入口和D出入口为预留口。车站设有自动扶梯、垂梯、公共洗手间等便民设备。车站以白色为主色调，重点区域的立柱和天花采用镜面不锈钢材质形成倒影反射效果，结合抽象折线层叠布置和智慧科技的蓝色灯光，萬意“海波翻动，滚滚向前”。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:27	00:06	9号线	3分50秒	5分55秒<br>
文锦	06:23	23:03	9号线	3分50秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:28	00:06	9号线	4分25秒	5分55秒<br>
文锦	06:23	23:03	9号线	4分25秒	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:27	01:06	9号线	4分钟	5分55秒<br>
文锦	06:23	00:03	9号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A出入口:<br>
怡海大道、公馆南街、深圳知识产权法庭、深圳前海蛇口自贸区人民检察院、前海国际会议中心、前海公证处、特区馆、万科前海企业公馆<br><br>
C出入口:<br>
前海大道、月亮湾大道、前湾壹街、前海展示厅、前海e站通服务中心、深圳市公安局警务工作办公室、前海蛇口自贸片区综合执法局、前海应急值班指挥中心、深圳市公安局交通警察支队前海交警中队、平南铁路有限公司<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 怡海地铁站（前海管理局西）<br>
M157、B990<br><br>
C出入口:<br>
公交站名： 前海合作区<br>
M492、M418<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "jiuhaoxian",
            title: "9号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>